// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-ruler[data-v-8882616e]{height:100%;flex:1 1 auto;display:flex;align-items:center}@media(max-width:767px){.vertical-ruler[data-v-8882616e]{display:none}}.spacer[data-v-8882616e]{flex:1 1 auto}.ruler[data-v-8882616e]{height:80%;flex:0 0 auto;border-left:.5px solid hsla(0,0%,100%,.08)}", ""]);
// Exports
module.exports = exports;
